import { AfterViewInit, Component, Input, OnInit, Sanitizer } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppService } from 'src/app/services/app.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment.prod';
import { SwiperOptions, Thumbs } from 'swiper';
import * as firebase from 'firebase';
const docRef = firebase.default.firestore.FieldPath.documentId();

declare var jquery:any;
declare var $ :any;
@Component({
  selector: 'app-landing-pages',
  templateUrl: './landing-pages.component.html',
  styleUrls: ['./landing-pages.component.less'],
})
export class LandingPagesComponent implements OnInit, AfterViewInit {
  @Input() dataId: string;
  fundSearchMobile: any[] = [
    {
      type: 'search',
      width: 'calc(100% - 135px)',
      selectValue: '',
      placeholder: 'Search by name ...',
      color: '#19D094',
    },
    {
      type: 'button',
      link: '/funds/all',
      label: 'See all',
      color: '#19D094',
    },
  ];
  bigBannerButton: any[] = [
    { label: 'Find your community', function: null, link: '/communities/all' },
  ];
  smallBannerBtn: any[] = [
    { label: 'Shop to give back', function: null, link: '' },
  ];
  toursBannerBtn: any[] = [
    { label: 'Discover Our Tours', function: null, link: '/tours' },
  ];
  greenBannerButton: any = [
    {
      label: 'The Live Love Impact',
      function: null,
    },
  ];

  homeLandingData: any = {
    introMedia: [{ image: '' }],
  };
  logoSlider: any[] = [
    {
      image:
        'https://storage.googleapis.com/livelove-dev.appspot.com/logo-home-1.png',
      ratio: 0.94,
      width: '200px',
    },
    {
      image:
        'https://storage.googleapis.com/livelove-dev.appspot.com/logo-home-2.png',
      ratio: 0.94,
      width: '200px',
    },
    {
      image:
        'https://storage.googleapis.com/livelove-dev.appspot.com/logo-home-3.png',
      ratio: 0.94,
      width: '200px',
    },
    {
      image:
        'https://storage.googleapis.com/livelove-dev.appspot.com/logo-home-4.png',
      ratio: 0.94,
      width: '200px',
    },
    {
      image:
        'https://storage.googleapis.com/livelove-dev.appspot.com/logo-home-5.png',
      ratio: 0.94,
      width: '200px',
    },
    {
      image:
        'https://storage.googleapis.com/livelove-dev.appspot.com/logo-home-6.png',
      ratio: 0.94,
      width: '200px',
    },
    {
      image:
        'https://storage.googleapis.com/livelove-dev.appspot.com/logo-home-7.png',
      ratio: 0.94,
      width: '200px',
    },
    {
      image:
        'https://storage.googleapis.com/livelove-dev.appspot.com/logo-home-8.png',
      ratio: 0.94,
      width: '200px',
    },
  ];
  impactContainer: any[] = [
    {
      logo: 'https://storage.googleapis.com/livelove-dev.appspot.com/megaphone.png',
      title: '1.5B',
      text: 'Organic Impression/year',
    },
    {
      logo: 'https://storage.googleapis.com/livelove-dev.appspot.com/maps-and-flags.png',
      title: '25',
      text: 'Countries activated',
    },
    {
      logo: 'https://storage.googleapis.com/livelove-dev.appspot.com/heart.png',
      title: '80K',
      text: 'Volunteers mobilized',
    },
    {
      logo: 'https://storage.googleapis.com/livelove-dev.appspot.com/tree.png',
      title: '50K',
      text: 'Trees planted',
    },
    {
      logo: 'https://storage.googleapis.com/livelove-dev.appspot.com/cart.png',
      title: '50K',
      text: 'Recurring merch customers',
    },
    {
      logo: 'https://storage.googleapis.com/livelove-dev.appspot.com/recycle.png',
      title: '320T',
      text: 'Of garbage recycled',
    },
    {
      logo: 'https://storage.googleapis.com/livelove-dev.appspot.com/meal.png',
      title: '6.2K',
      text: 'Meals Distributed',
    },
    {
      logo: 'https://storage.googleapis.com/livelove-dev.appspot.com/agreement.png',
      title: '86',
      text: 'Public & Private Partners',
    },
    {
      logo: 'https://storage.googleapis.com/livelove-dev.appspot.com/calendar.png',
      title: '140',
      text: 'Events For Change',
    },
    {
      logo: 'https://storage.googleapis.com/livelove-dev.appspot.com/group.png',
      title: '2M',
      text: 'Active Followers',
    },
    {
      logo: 'https://storage.googleapis.com/livelove-dev.appspot.com/like.png',
      title: '38M',
      text: 'Cumulitive Likes',
    },
    {
      logo: 'https://storage.googleapis.com/livelove-dev.appspot.com/users-group.png',
      title: '275',
      text: 'Live Love Chapter',
    },
  ];
  fundSearchArray: any[] = [
    {
      type: 'select',
      width: '140px',
      selectValue: 'cause',
      options: ['cause', 'Beirut Explosion Damage Relief Fund'],
      color: '#19D094',
    },
    {
      type: 'search',
      width: '240px',
      selectValue: '',
      placeholder: 'Search by name ...',
      color: '#19D094',
    },
    {
      type: 'button',
      link: '/funds/all',
      label: 'See all',
      color: '#19D094',
    },
  ];
  championSearchMobile: any[] = [
    {
      type: 'search',
      width: 'calc(100% - 135px)',
      selectValue: '',
      placeholder: 'Search by name ...',
      color: '#19D094',
    },
    {
      type: 'button',
      link: '/funds/campaigns',
      label: 'See all',
      color: '#19D094',
    },
  ];
  championSearchArray: any[] = [
    {
      type: 'search',
      width: '240px',
      selectValue: '',
      placeholder: 'Search by name ...',
      color: '#19D094',
    },
    {
      type: 'button',
      link: '/funds/campaigns',
      label: 'See all',
      color: '#19D094',
    },
  ];
  swiperParam: SwiperOptions = {
    direction: 'horizontal',
    speed: 400,
    slidesPerView: 'auto',
    spaceBetween: 50,
    navigation: {
      nextEl: '.arrow-next',
      prevEl: '.arrow-prev',
    },
  };
  data: any = {
    introMedia: null,
    sections: null,
  };
  galleryOptions = {
    index: 0,
    interval: null,
    intervalTimeout: 4000,
    hold: false,
  };
  fundGallery = {
    index: 0,
    interval: null,
    intervalTimeout: 4000,
    hold: false,
  };

  localAppService: AppService;
  url: string;
  itemId: string = Math.random().toString().split('.')[1];
  sliderData: any[] = [];
  selectedDetails: any;
  loaded: boolean;
  constructor(
    private router: Router,
    private authService: AuthService,
    public sanitizer: DomSanitizer,
    private appService: AppService
  ) {}

  ngOnInit(): void {
    console.log(this.itemId);
    
    this.url = window.location.pathname;
    this.localAppService = this.appService;
    this.authService.db
      .collection('static-content')
      .doc(this.appService.country.value)
      .collection('static-content')
      .doc(this.dataId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          console.log(doc.data());
          this.data = doc.data().data;
          if (this.data.introMedia && this.data.introMedia.length > 1) {
            this.initializeSlideshow();
          }
          this.data.sections.forEach((element) => {
            if (element.collection && element.data.length > 0) {
              console.log(element);
              this.authService.db
                .collection(element.collection)
                // .where('country', '==', this.appService.country.value)
                .where(docRef, 'in', element.data)
                .get()
                .then((docList) => {
                  element.data = [];
                  docList.forEach((doc) => {
                    console.log(doc, 'doc');
                    let dataObj = doc.data();
                    dataObj.id = doc.id;
                    element.data.push(dataObj);
                  });
                  console.log(this.data, 'dataaaaaa');
                })
                .finally(() => {
                  this.loaded = true;
                });
            }
            if (
              element.sectionLeft &&
              element.sectionLeft.collection &&
              element.sectionLeft.data.length > 0
            ) {
              console.log(element);
              this.authService.db
                .collection(element.sectionLeft.collection)
                .where('country', '==', this.appService.country.value)
                .where(docRef, 'in', element.sectionLeft.data)
                .get()
                .then((docList) => {
                  element.sectionLeft.data = [];
                  docList.forEach((doc) => {
                    console.log(doc, 'doc');
                    let dataObj = doc.data();
                    dataObj.id = doc.id;
                    element.sectionLeft.data.push(dataObj);
                  });
                  console.log(this.data, 'dataaaaaa');
                });
            }
            if (
              element.sectionRight &&
              element.sectionRight.collection &&
              element.sectionRight.data.length > 0
            ) {
              console.log(element.sectionRight);
              this.authService.db
                .collection(element.sectionRight.collection)
                .where('country', '==', this.appService.country.value)
                .where(docRef, 'in', element.sectionRight.data)
                .get()
                .then((docList) => {
                  element.sectionRight.data = [];
                  docList.forEach((doc) => {
                    console.log(doc, 'doc');
                    let dataObj = doc.data();
                    dataObj.id = doc.id;
                    element.sectionRight.data.push(dataObj);
                  });
                  console.log(this.data, 'dataaaaaa');
                })
                .finally(() => {
                  this.loaded = true;
                });
            }
          });
          let videoSection = this.data.sections.filter(
            (elt) => elt.type == 'video-banner'
          );
          if (videoSection.length > 0) {
            videoSection.forEach((element) => {
              element.video = this.sanitizer.bypassSecurityTrustResourceUrl(
                element.video
              );
            });
          }
          this.loaded = true;
          console.log(this.data, this.appService.targetScroll);
        }
      });
    // this.data = environment.strings.homePage;
  }
  // async insertComs() {
  //   let coms = [{'link': 'instagram.com/Live.love.ajaltoun', 'location': 'Lebanon', 'urlKey': 'Ajaltoun.png', 'title': 'Ajaltoun'}, {'link': 'instagram.com/Live.Love.Hebarieh', 'location': 'Lebanon', 'urlKey': 'Hebarieh.jpg', 'title': 'Hebarieh'}, {'link': 'instagram.com/Livelove_bkaatouta', 'location': 'Lebanon', 'urlKey': 'Bkaatouta.png', 'title': 'Bkaatouta'}, {'link': 'instagram.com/Livelove_maghdouche', 'location': 'Lebanon', 'urlKey': 'Maghdouche.jpg', 'title': 'Maghdouche'}, {'link': 'instagram.com/Livelove.baalbeck', 'location': 'Lebanon', 'urlKey': 'Baalbeck.jpg', 'title': 'Baalbeck'}, {'link': 'instagram.com/Livelove.beitchabab', 'location': 'Lebanon'}, {'link': 'instagram.com/livelove.bickfaya', 'location': 'Lebanon', 'urlKey': 'Bickfaya.png', 'title': 'Bickfaya'}, {'link': 'instagram.com/Livelove.bzebdine', 'location': 'Lebanon', 'urlKey': 'Bzebdine.png', 'title': 'Bzebdine'}, {'link': 'instagram.com/livelove.rayfoun', 'location': 'Lebanon', 'urlKey': 'Rayfoun.png', 'title': 'Rayfoun'}, {'link': 'instagram.com/Livelove.saghbine', 'location': 'Lebanon', 'urlKey': 'Saghbine.jpg', 'title': 'Saghbine'}, {'link': 'instagram.com/livelove.tyre', 'location': 'Lebanon', 'urlKey': 'Tyre.jpg', 'title': 'Tyre'}, {'link': 'instagram.com/Liveloveaana', 'location': 'Lebanon', 'urlKey': 'Aana.png', 'title': 'Aana'}, {'link': 'instagram.com/liveloveachrafieh', 'location': 'Lebanon', 'urlKey': 'Achrafieh.jpg', 'title': 'Achrafieh'}, {'link': 'instagram.com/LiveLoveAinAata', 'location': 'Lebanon', 'urlKey': 'Ain_Aata.png', 'title': 'Ain Aata'}, {'link': 'instagram.com/Liveloveainzhalta', 'location': 'Lebanon', 'urlKey': 'Ain_Zhalta.jpg', 'title': 'Ain Zhalta'}, {'link': 'instagram.com/liveloveajloun', 'location': 'Lebanon', 'urlKey': 'Ajloun.jpg', 'title': 'Ajloun'}, {'link': 'instagram.com/liveloveakkar', 'location': 'Lebanon', 'urlKey': 'Akkar.jpg', 'title': 'Akkar'}, {'link': 'instagram.com/Liveloveakkar', 'location': 'Lebanon', 'urlKey': 'Akkar.jpg', 'title': 'Akkar'}, {'link': 'instagram.com/LiveLoveAkoura', 'location': 'Lebanon', 'urlKey': 'Akoura.png', 'title': 'Akoura'}, {'link': 'instagram.com/LiveloveAkoura', 'location': 'Lebanon', 'urlKey': 'Akoura.png', 'title': 'Akoura'}, {'link': 'instagram.com/Liveloveakoura', 'location': 'Lebanon', 'urlKey': 'Akoura.png', 'title': 'Akoura'}, {'link': 'instagram.com/Liveloveandaket', 'location': 'Lebanon', 'urlKey': 'Andaket.jpg', 'title': 'Andaket'}, {'link': 'instagram.com/Livelovearamoun', 'location': 'Lebanon', 'urlKey': 'Aramoun.jpg', 'title': 'Aramoun'}, {'link': 'instagram.com/LiveLoveBaakline', 'location': 'Lebanon', 'urlKey': 'Baakline.jpg', 'title': 'Baakline'}, {'link': 'instagram.com/Livelovebaflay', 'location': 'Lebanon', 'urlKey': 'Baflay.png', 'title': 'Baflay'}, {'link': 'instagram.com/Livelovebarhalioun', 'location': 'Lebanon', 'urlKey': 'Barhalioun.jpg', 'title': 'Barhalioun'}, {'link': 'instagram.com/Livelovebaskinta', 'location': 'Lebanon', 'urlKey': 'Baskinta.png', 'title': 'Baskinta'}, {'link': 'instagram.com/livelovebayada', 'location': 'Lebanon', 'urlKey': 'Bayada.jpg', 'title': 'Bayada'}, {'link': 'instagram.com/Livelovebazoun', 'location': 'Lebanon', 'urlKey': 'Bazoun.jpg', 'title': 'Bazoun'}, {'link': 'instagram.com/Livelovebcharre', 'location': 'Lebanon', 'urlKey': 'Bcharre.jpg', 'title': 'Bcharre'}, {'link': 'instagram.com/Livelovebeitmellat', 'location': 'Lebanon', 'urlKey': 'Beit_Mellat.jpg', 'title': 'Beit Mellat'}, {'link': 'instagram.com/Livelovebejjeh', 'location': 'Lebanon', 'urlKey': 'Bejjeh.jpg', 'title': 'Bejjeh'}, {'link': 'instagram.com/LiveloveBekaaKafra', 'location': 'Lebanon'}, {'link': 'instagram.com/Liveloveberti', 'location': 'Lebanon', 'urlKey': 'Berti.png', 'title': 'Berti'}, {'link': 'instagram.com/Livelovebickfaya', 'location': 'Lebanon', 'urlKey': 'Bickfaya.png', 'title': 'Bickfaya'}, {'link': 'instagram.com/Livelovebireh', 'location': 'Lebanon', 'urlKey': 'Bireh.png', 'title': 'Bireh'}, {'link': 'instagram.com/Livelovebmohray', 'location': 'Lebanon', 'urlKey': 'Bmohray.jpg', 'title': 'Bmohray'}, {'link': 'instagram.com/livelovebmohray', 'location': 'Lebanon', 'urlKey': 'Bmohray.jpg', 'title': 'Bmohray'}, {'link': 'instagram.com/Livelovebyblos', 'location': 'Lebanon', 'urlKey': 'Byblos.jpg', 'title': 'Byblos'}, {'link': 'instagram.com/livelovechartoun', 'location': 'Lebanon', 'urlKey': 'Chartoun.png', 'title': 'Chartoun'}, {'link': 'instagram.com/livelovechbenieh', 'location': 'Lebanon', 'urlKey': 'Chbenieh.png', 'title': 'Chbenieh'}, {'link': 'instagram.com/Livelovechekka', 'location': 'Lebanon', 'urlKey': 'Chekka.png', 'title': 'Chekka'}, {'link': 'instagram.com/Livelovedeirelahmar', 'location': 'Lebanon', 'urlKey': 'Deir_El_Ahmar.jpg', 'title': 'Deir El Ahmar'}, {'link': 'instagram.com/Livelovedouma', 'location': 'Lebanon', 'urlKey': 'Douma.png', 'title': 'Douma'}, {'link': 'instagram.com/LiveLoveFalougha', 'location': 'Lebanon', 'urlKey': 'Falougha.png', 'title': 'Falougha'}, {'link': 'instagram.com/Livelovefarayaa', 'location': 'Lebanon', 'urlKey': 'Faraya.jpg', 'title': 'Faraya'}, {'link': 'instagram.com/liveloveghosta', 'location': 'Lebanon', 'urlKey': 'Ghosta.jpg', 'title': 'Ghosta'}, {'link': 'instagram.com/liveloveghouma', 'location': 'Lebanon', 'urlKey': 'Ghouma.jpg', 'title': 'Ghouma'}, {'link': 'instagram.com/livelovehadat', 'location': 'Lebanon', 'urlKey': 'Hadat.png', 'title': 'Hadat'}, {'link': 'instagram.com/livelovehadchit', 'location': 'Lebanon', 'urlKey': 'Hadchit.jpg', 'title': 'Hadchit'}, {'link': 'instagram.com/Livelovehakel', 'location': 'Lebanon', 'urlKey': 'Hakel.png', 'title': 'Hakel'}, {'link': 'instagram.com/livelovehamat', 'location': 'Lebanon', 'urlKey': 'Hamat.jpg', 'title': 'Hamat'}, {'link': 'instagram.com/Livelovehardine', 'location': 'Lebanon'}, {'link': 'instagram.com/Livelovehasroun', 'location': 'Lebanon', 'urlKey': 'Hasroun.jpg', 'title': 'Hasroun'}, {'link': 'instagram.com/Liveloveijdabra', 'location': 'Lebanon', 'urlKey': 'Ijdabra.jpg', 'title': 'Ijdabra'}, {'link': 'instagram.com/LiveloveJdeideh', 'location': 'Lebanon', 'urlKey': 'Jdeideh.png', 'title': 'Jdeideh'}, {'link': 'instagram.com/Livelovejieh', 'location': 'Lebanon', 'urlKey': 'Jieh.jpg', 'title': 'Jieh'}, {'link': 'instagram.com/LiveLoveJounieh', 'location': 'Lebanon', 'urlKey': 'Jounieh.png', 'title': 'Jounieh'}, {'link': 'instagram.com/Livelovekaaelrim', 'location': 'Lebanon', 'urlKey': 'Kaa_El_Rim.png', 'title': 'Kaa El Rim'}, {'link': 'instagram.com/Livelovekfardebian', 'location': 'Lebanon', 'urlKey': 'Kfardebian.jpg', 'title': 'Kfardebian'}, {'link': 'instagram.com/Livelovekfarfou', 'location': 'Lebanon', 'urlKey': 'Kfarfou.jpg', 'title': 'Kfarfou'}, {'link': 'instagram.com/LiveLoveKfarhelda', 'location': 'Lebanon', 'urlKey': 'Kfarhelda.png', 'title': 'Kfarhelda'}, {'link': 'instagram.com/livelovekfarmatta', 'location': 'Lebanon', 'urlKey': 'Kfarmatta.png', 'title': 'Kfarmatta'}, {'link': 'instagram.com/livelovekfarmishki', 'location': 'Lebanon', 'urlKey': 'Kfarmishki.png', 'title': 'Kfarmishki'}, {'link': 'instagram.com/Livelovekfarmishki', 'location': 'Lebanon', 'urlKey': 'Kfarmishki.png', 'title': 'Kfarmishki'}, {'link': 'instagram.com/Livelovekfarmishki', 'location': 'Lebanon', 'urlKey': 'Kfarmishki.png', 'title': 'Kfarmishki'}, {'link': 'instagram.com/livelovekleiat', 'location': 'Lebanon', 'urlKey': 'Kleiat.jpg', 'title': 'Kleiat'}, {'link': 'instagram.com/livelovekleiat', 'location': 'Lebanon', 'urlKey': 'Kleiat.jpg', 'title': 'Kleiat'}, {'link': 'instagram.com/livelovelaklouk', 'location': 'Lebanon', 'urlKey': 'Laklouk.jpg', 'title': 'Laklouk'}, {'link': 'instagram.com/LiveLoveLehfed', 'location': 'Lebanon', 'urlKey': 'Lehfed.png', 'title': 'Lehfed'}, {'link': 'instagram.com/Livelovemayrouba', 'location': 'Lebanon', 'urlKey': 'Mayrouba.jpg', 'title': 'Mayrouba'}, {'link': 'instagram.com/LiveLoveMina', 'location': 'Lebanon', 'urlKey': 'Mina.png', 'title': 'Mina'}, {'link': 'instagram.com/liveloveqartaba', 'location': 'Lebanon', 'urlKey': 'Qartaba.png', 'title': 'Qartaba'}, {'link': 'instagram.com/liveloveqawzah', 'location': 'Lebanon', 'urlKey': 'Qawzah.jpg', 'title': 'Qawzah'}, {'link': 'instagram.com/LiveLoveRachiine', 'location': 'Lebanon', 'urlKey': 'Rachiine.jpg', 'title': 'Rachiine'}, {'link': 'instagram.com/LiveLoveRashaya', 'location': 'Lebanon', 'urlKey': 'Rashaya.png', 'title': 'Rashaya'}, {'link': 'instagram.com/Liveloverassbaalbeck', 'location': 'Lebanon', 'urlKey': 'Rass_Baalbeck.jpg', 'title': 'Rass Baalbeck'}, {'link': 'instagram.com/livelovermaich', 'location': 'Lebanon', 'urlKey': 'Rmaich.jpg', 'title': 'Rmaich'}, {'link': 'instagram.com/livelovesaghbine', 'location': 'Lebanon', 'urlKey': 'Saghbine.jpg', 'title': 'Saghbine'}, {'link': 'instagram.com/Livelovesalimaa', 'location': 'Lebanon', 'urlKey': 'Salima.png', 'title': 'Salima'}, {'link': 'instagram.com/Livelovesawfar', 'location': 'Lebanon', 'urlKey': 'Sawfar.jpg', 'title': 'Sawfar'}, {'link': 'instagram.com/livelovescout', 'location': 'Lebanon', 'urlKey': 'Scout.png', 'title': 'Scout'}, {'link': 'instagram.com/Livelovewadichahrour', 'location': 'Lebanon', 'urlKey': 'Wadi_Chahrour.png', 'title': 'Wadi Chahrour'}, {'link': 'instagram.com/Liveloveyarine', 'location': 'Lebanon', 'urlKey': 'Yarine.jpg', 'title': 'Yarine'}, {'link': 'instagram.com/livelovezahleh', 'location': 'Lebanon', 'urlKey': 'Zahleh.png', 'title': 'Zahleh'}]
  //   coms.forEach(async com => {
  //     await this.authService.db.collection('communities').add(com)
  //   })
  // }

  ngAfterViewInit() {
    setTimeout(() => {
      console.log(this.data, 'dataa')
      if(this.data.sections){
        this.calculateImageHeight();
      }
     
      $('.noWidow').each(function (i, d) {
        // console.log(d)
        $(d).html(
          $(d)
            .text()
            .replace(/\s([^\s<]+)\s*$/, '\u00A0$1')
        );
      });
    }, 3000);
  }

  calculateImageHeight() {
    let section = this.data.sections.filter(elt => elt.type == 'fund-grid')[0]
    console.log(section)
    if(section){
      section.gridData.forEach((elt) => {
        let image = document.getElementById(elt.image);
        console.log(image, elt.ratio);
        if (image) {
          image.style.height =
            (
              +window.getComputedStyle(image).width.split('px')[0] / +elt.ratio
            ).toString() + 'px';
        }
      });
    }
  }

  getData(index, subIndex) {
    console.log(index, subIndex);
    this.selectedDetails = this.data.sections[index].data[subIndex];
    console.log(this.selectedDetails);
  }

  initializeSlideshow(itemLength = null) {
    this.resetGalleryInterval(itemLength);
  }
  galleryNavigate(index, fund = false) {
    if (fund) {
      this.fundGallery.index = index;
    } else {
      this.stopGalleryInterval();
      this.galleryOptions.index = index;
      this.resetGalleryInterval();
    }
  }
  resetGalleryInterval(itemLength = null, fundLength = null) {
    itemLength = itemLength || this.data.introMedia.length;
    if (itemLength && itemLength > 1) {
      this.galleryOptions.interval = setInterval(() => {
        this.galleryOptions.index =
          this.galleryOptions.index + 1 == itemLength
            ? 0
            : this.galleryOptions.index + 1;
      }, this.galleryOptions.intervalTimeout);
    }
  }

  emitFunction(functionn = null, link = null, target = null, formId = null) {
    console.log(functionn);
    if (functionn != null) {
      if (functionn == 'openForm()') {
        this.openForm(formId);
      } else if (functionn == 'scrollToElement()') {
        this.scrollToElement(target);
      }
    }
    if (link != null) {
      this.router.navigate([link]);
    }
  }

  openForm(formId) {
    this.appService.openForm(formId);
  }

  scrollToElement(element): void {
    console.log(element);
    let elt = document.getElementById(element);
    console.log(elt);
    elt.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest',
    });
  }

  stopGalleryInterval() {
    clearInterval(this.galleryOptions.interval);
  }
  navigateTo(link = null, target = null, itemId = null) {
    console.log(itemId);
    this.appService.targetScroll = target;

    if (link && (link.indexOf('http') > -1 || link.indexOf('instagram') > -1)) {
      if (link.indexOf('instagram') > -1) {
        window.open('https://' + link, '_blank');
      } else {
        window.open(link, '_blank');
      }
    }  else if (link == 'openForm') {
      this.openForm(itemId);
    } else if (link && itemId) {
      console.log(link, itemId);
      this.router.navigate([link + '/' + itemId]);
    } else {
      this.router.navigate([link]);
    }
    console.log(window.location.pathname);
    // this.router.navigate([link])
  }

  navigateRight(data) {
    if (this.galleryOptions.index == data.length - 1) {
      this.galleryOptions.index = 0;
    } else {
      this.galleryOptions.index = this.galleryOptions.index + 1;
    }
  }

  navigateLeft(data) {
    if (this.galleryOptions.index == 0) {
      this.galleryOptions.index = data.length - 1;
    } else {
      this.galleryOptions.index = this.galleryOptions.index - 1;
    }
  }

  hoverOnGrid(id) {
    document.getElementById(id).classList.add('tour-hover');
    console.log(document.getElementById(id));
  }

  removeHoverOnGrid(id) {
    document.getElementById(id).classList.remove('tour-hover');
  }
}
